(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbb-essentials"] && !Shopify.designMode) return;
  try {
    
(function(){function openReviewForm(){var id=decodeURIComponent(location.hash.slice(1));if(!id.startsWith('bbb-review-form-'))return;var panel=document.getElementById(id);if(panel&&panel.matches('.bbb-review-form-panel'))panel.open=true;}openReviewForm();window.addEventListener('hashchange',openReviewForm);document.addEventListener('click',function(event){var link=event.target.closest('.bbb-essential-heading a');if(!link)return;var id=link.hash.slice(1);var panel=document.getElementById(id);if(panel)panel.open=true;});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbb-info"] && !Shopify.designMode) return;
  try {
    
(function () {
  function openTopic() {
    var id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); }
    catch (_) { return; }
    if (!id) return;
    var node = document.getElementById(id);
    if (node && node.matches('.bbb-info-faq details')) node.open = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openTopic, { once: true });
  else openTopic();
  window.addEventListener('hashchange', openTopic);
  window.addEventListener('pageshow', openTopic);
  document.addEventListener('shopify:section:load', openTopic);
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest('a[href]');
    if (!link) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return; }
    if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search && url.hash === location.hash) openTopic();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbb-west-coast"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bbb-print-preview')) {
  customElements.define('bbb-print-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.previewReady) return;
      this.previewReady = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-print]');
        if (!button || !this.contains(button)) return;
        const color = button.dataset.print;
        this.querySelectorAll('[data-print-panel]').forEach(panel => { panel.hidden = panel.dataset.printPanel !== color; });
        this.querySelectorAll('button[data-print]').forEach(control => { control.setAttribute('aria-pressed', String(control === button)); });
        const label = this.querySelector('[data-print-label]');
        if (label) label.textContent = button.dataset.label;
        const link = this.querySelector('[data-product-link]');
        const source = this.querySelector('[data-variant-links]');
        if (link && source) {
          try {
            const matches = JSON.parse(source.textContent).filter(variant => variant.options.includes(button.dataset.label));
            const match = matches.find(variant => variant.available) || matches[0];
            if (match) link.href = match.url;
          } catch (error) { /* Preserve the original product URL. */ }
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
